import React from 'react';
import HeroFull from '../components/sections/HeroFull';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import Pricing from '../components/sections/Pricing';
import Testimonial from '../components/sections/TestimonialCarousel';
import Cta from '../components/sections/Cta';

class Home extends React.Component {
  render() {
    return (
      <React.Fragment>
        <HeroFull className="illustration-section-01" />
        <FeaturesTiles className="illustration-section-02" />
        <FeaturesSplit invertMobile topDivider imageFill />
        {null && <Pricing topDivider pricingSwitcher />}
        {null && <Testimonial className="illustration-section-07" />}
        <Cta
          topDivider
          title="Looking for 3D printing?"
          description="We also design and sell custom 3D printed keychains. Come see what we have."
          buttonText="See 3D printing"
          buttonHref="/3d-printing"
        />
      </React.Fragment>
    );
  }
}

export default Home;